import React, { useEffect, useState } from 'react';
import './../../css/table.css';
import axios from 'axios';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Spinner } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useFormik } from 'formik';
import * as yup from 'yup';
import InputCustom from '../Auth/InputCustom';
import styles from '../Auth/input.module.css';
import TextAreaCustom from '../Auth/TextAreaCustom';

const MySwal = withReactContent(Swal);

const NewPost = () => {
  const [loader, setLoader] = useState(false);
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    axios
      .get(`https://arianaapp.arianaapply.com/api/V1/show-country-filter`)
      .then((res) => {
        console.log(res);
        setCountries(res.data);
      })
      .catch((err) => {
        console.log(err.response);
      });
  }, []);

  const initialValues = {
    title: '',
    city: '',
    country: '',
    company: '',
    apply_link: '',
    responsibility: '',
    document: '',
    type: '',
    img: '',
    subject: '',
    salary: '',
    deadline: '',
  };
  const validationSchema = yup.object({
    title: yup.string().required('وارد کردن عنوان الزامیست'),
    title_fa: yup.string().required('وارد کردن عنوان به فارسی الزامیست'),
    city: yup.string().required('وارد کردن شهر الزامیست'),
    city_fa: yup.string().required('وارد کردن شهر به فارسی الزامیست'),
    country: yup.string().required('وارد کردن کشور الزامیست'),
    company: yup.string().required('وارد کردن شرکت الزامیست'),
    apply_link: yup.string().required('وارد کردن لینک اپلای الزامیست'),
    responsibility: yup.string().required('وارد کردن مسئولیت الزامیست'),
    document: yup.string().required('وارد کردن مدارک الزامیست'),
    type: yup.string().required('وارد کردن دسته بندی الزامیست'),
    subject: yup.string().required('وارد کردن موضوع الزامیست'),
    deadline: yup.string().required('وارد کردن ددلاین الزامیست'),
  });

  const onSubmit = (state) => {
    axios
      .post('https://arianaapp.arianaapply.com/panel/create-job-opportunity', {
        title: state.title,
        title_fa: state.title_fa,
        city: state.city,
        city_fa: state.city_fa,
        country: state.country,
        company: state.company,
        apply_link: state.apply_link,
        responsibility: state.responsibility,
        document: state.document,
        type: state.type,
        img: '',
        subject: state.subject,
        salary: state.salary ? state.salary : 'توافقی',
        deadline: state.deadline,
      })
      .then((response) => {
        console.log(response);
        MySwal.fire({
          title: 'با موفقیت ثبت شد',
          icon: 'success',
        }).then((result) => {
          if (result) {
            window.location.reload();
          }
        });
      })
      .catch((err) => {
        console.log(err);
        MySwal.fire({
          title: 'دوباره امتحان کنید',
          icon: 'error',
        });
      });
  };

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
    validateOnMount: true,
  });

  return (
    <div className='index'>
      {countries.length > 0 ? (
        <form method='POST' onSubmit={formik.handleSubmit}>
          <h2>ساخت موقعیت شغلی جدید</h2>
          <InputCustom
            name='title'
            type='text'
            label='عنوان شغلی...'
            formikHandler={formik.getFieldProps('title')}
            formikErrors={formik.errors.title && formik.touched.title}
            formikErrorsName={formik.errors.title}
          />
          <InputCustom
            name='title_fa'
            type='text'
            label=' عنوان شغلی به فارسی...'
            formikHandler={formik.getFieldProps('title_fa')}
            formikErrors={formik.errors.title_fa && formik.touched.title_fa}
            formikErrorsName={formik.errors.title_fa}
          />
          <InputCustom
            name='subject'
            type='text'
            label='موضوع...'
            formikHandler={formik.getFieldProps('subject')}
            formikErrors={formik.errors.subject && formik.touched.subject}
            formikErrorsName={formik.errors.subject}
          />
          <InputCustom
            name='city'
            type='text'
            label='شهر'
            formikHandler={formik.getFieldProps('city')}
            formikErrors={formik.errors.city && formik.touched.city}
            formikErrorsName={formik.errors.city}
          />
          <InputCustom
            name='city_fa'
            type='text'
            label='شهر به فارسی...'
            formikHandler={formik.getFieldProps('city_fa')}
            formikErrors={formik.errors.city_fa && formik.touched.city_fa}
            formikErrorsName={formik.errors.city_fa}
          />
          <div className={styles.inputWrap}>
            <label className={styles.label}>کشور...</label>
            <select
              name='country'
              className={
                formik.errors.country && formik.touched.country
                  ? styles.inputError
                  : styles.input
              }
              {...formik.getFieldProps('country')}>
              <option value=''>انتخاب کنید...</option>
              {countries?.map((c) => (
                <option key={c.country} value={c.country}>
                  {c.country}
                </option>
              ))}
            </select>
            {formik.errors.country && formik.touched.country && (
              <p className={styles.errorText}>{formik.errors.country}</p>
            )}
          </div>
          <InputCustom
            name='company'
            type='text'
            label='شرکت...'
            formikHandler={formik.getFieldProps('company')}
            formikErrors={formik.errors.company && formik.touched.company}
            formikErrorsName={formik.errors.company}
          />
          <InputCustom
            name='salary'
            type='text'
            label='حقوق دریافتی...'
            formikHandler={formik.getFieldProps('salary')}
            formikErrors={formik.errors.salary && formik.touched.salary}
            formikErrorsName={formik.errors.salary}
          />
          <InputCustom
            name='apply_link'
            type='text'
            label='لینک اپلای...'
            formikHandler={formik.getFieldProps('apply_link')}
            formikErrors={formik.errors.apply_link && formik.touched.apply_link}
            formikErrorsName={formik.errors.apply_link}
          />
          <InputCustom
            name='deadline'
            type='date'
            label='ددلاین..'
            formikHandler={formik.getFieldProps('deadline')}
            formikErrors={formik.errors.deadline && formik.touched.deadline}
            formikErrorsName={formik.errors.deadline}
          />
          <div className={styles.inputWrap}>
            <label className={styles.label}>دسته بندی....</label>
            <select
              name='type'
              className={
                formik.errors.type && formik.touched.type
                  ? styles.inputError
                  : styles.input
              }
              {...formik.getFieldProps('type')}>
              {/* <option value=''>انتخاب کنید...</option>
              <option value='accounting'>حسابداری</option>
              <option value='medical'>پزشکی</option>
              <option value='engineering'>مهندسی</option>
              <option value='teacher'>معلم</option>
              <option value='consultant'>مشاور</option>
              <option value='marketing'>بازاریابی و فروش</option>
              <option value='art'>هنر</option>
              <option value='law'>حقوق</option>
              <option value='management'>مدیریت</option> */}




              <option value=''>انتخاب کنید...</option>

              /* فناوری */
              <option value='software_it'>فناوری اطلاعات و نرم‌افزار</option>
              <option value='cybersecurity'>امنیت سایبری و شبکه</option>
              <option value='data_ai'>داده، هوش مصنوعی و تحلیل</option>

              /* مهندسی */
              <option value='engineering_civil'>مهندسی عمران و معماری</option>
              <option value='engineering_mechanical'>مهندسی مکانیک</option>
              <option value='engineering_electrical'>مهندسی برق و الکترونیک</option>
              <option value='engineering_industrial'>مهندسی صنایع و تولید</option>
              <option value='engineering_other'>سایر رشته‌های مهندسی</option>

              /* سلامت */
              <option value='medicine'>پزشکی</option>
              <option value='nursing'>پرستاری</option>
              <option value='dentistry'>دندانپزشکی</option>
              <option value='pharmacy'>داروسازی</option>
              <option value='allied_health'>علوم آزمایشگاهی و مشاغل درمانی</option>
              <option value='caregiving'>مراقبت از سالمندان و مراقبت شخصی</option>

              /* مالی */
              <option value='accounting_finance'>حسابداری و مالی</option>
              <option value='banking_insurance'>بانکداری، سرمایه‌گذاری و بیمه</option>

              /* کسب‌وکار */
              <option value='marketing_sales'>بازاریابی، فروش و توسعه کسب‌وکار</option>
              <option value='customer_support'>پشتیبانی و خدمات مشتری</option>
              <option value='management'>مدیریت و رهبری</option>
              <option value='hr_recruitment'>منابع انسانی و استخدام</option>
              <option value='administration'>امور اداری و دفتری</option>
              <option value='consulting'>مشاوره</option>

               /* حقوق و آموزش */
              <option value='legal'>حقوق و امور قانونی</option>
              <option value='education'>آموزش و تدریس</option>
              <option value='science_research'>علوم و پژوهش</option>

               /* خلاقیت  */
              <option value='design_creative'>طراحی، هنر و تولید محتوا</option>
              <option value='media_communication'>رسانه، ارتباطات و روابط عمومی</option>

              /* عملیات و خدمات */
              <option value='construction_trades'>ساختمان و مشاغل فنی</option>
              <option value='manufacturing'>تولید و کارخانه</option>
              <option value='logistics_supply'>لجستیک، حمل‌ونقل و زنجیره تأمین</option>
              <option value='hospitality_tourism'>هتلداری، گردشگری و رستوران</option>
              <option value='retail'>خرده‌فروشی و فروشگاه</option>
              <option value='agriculture_environment'>کشاورزی، محیط‌زیست و منابع طبیعی</option>
              <option value='government_nonprofit'>دولتی و سازمان‌های غیرانتفاعی</option>

              <option value='other'>سایر</option>
            </select>
            {formik.errors.type && formik.touched.type && (
              <p className={styles.errorText}>{formik.errors.type}</p>
            )}
          </div>

          <TextAreaCustom
            name='responsibility'
            type='text'
            label='مسئولیت ها..'
            formikHandler={formik.getFieldProps('responsibility')}
            formikErrors={
              formik.errors.responsibility && formik.touched.responsibility
            }
            formikErrorsName={formik.errors.responsibility}
          />

          <TextAreaCustom
            name='document'
            type='text'
            label='مدارک..'
            formikHandler={formik.getFieldProps('document')}
            formikErrors={formik.errors.document && formik.touched.document}
            formikErrorsName={formik.errors.document}
          />
          <div className='inputBox'>
            <button
              type='submit'
              className={!formik.isValid ? 'btn-gray' : 'btn-success'}
              disabled={!formik.isValid}>
              ثبت
            </button>
          </div>
        </form>
      ) : (
        <Spinner animation='border' variant='primary' />
      )}
    </div>
  );
};

export default NewPost;
